// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__18KiJ","dark":"app_dark__MxmzH","light":"app_light__3QlDF"};